/**
 * Initial form data state with default values
 */
export const initialFormData = {
    name: '',
    email_Id: '',
    contactNo: '',
    address: '',
    educationLevel: '',
    educationCourse: '',
    department: '',
    passedout: '',
    studentStatus: '',
    dob: '',
    source: 'Direct',  // Set default value here
    classType: '',
    learningMode: '',
    batch: '',
    branch: '',
    adminName: '',
    studentRequirement: '',
    courseType: '',
    course: '',
    otherDepartment: ''
  };
  
  /**
   * Education courses by education level
   */
  export const educationCourses = {
    Diploma: ['Computer Science', 'Mechanical', 'Civil'],
    UG: ['B.Sc', 'B.Com', 'B.A', 'B.E/B.Tech', 'BCA', 'BBA'],
    PG: ['M.Sc', 'M.Com', 'M.A', 'M.E/M.Tech', 'MCA', 'MBA'],
  };
  
  /**
   * Class types
   */
  export const classTypes = ['Regular', 'Weekend'];
  
  /**
   * Branch locations
   */
  export const branches = [
    'Gandhipuram', 
    'Hosur',
    'Poonamallee', 
    'Padi',
    'Malumichampatti',
    'Marathahalli', 
    'Saravanampatti',
    'Tambaram',
    'Tiruppur',
    'Vadapalani',
    'Velachery',    
  ];